import { DEAL_LABELS } from "./common";

export const FEATURES_NAME = {
  // DASHBOARD_FEATURES
  DASHBOARD_DISMISS_DUMMY: "dashboard.dismiss_dummy",

  // DOCUMENT_FEATURE
  DOCUMENTS_EXPORT_TO_DOCX: "documents.export_to_docx",
  DOCUMENTS_THIRD_PARTY_UPLOAD: "documents.third_party_upload",
  ESIGN_SIGNATURES: "documents.esign",

  // PIPELINE_FEATURES
  PIPELINE_CREATE_DOCUMENT: "pipeline.create_document",
  PIPELINE_CREATE_OPPORTUNITY: "pipeline.create_opportunity",

  // PRICEBOOK_FEATURES
  PRICEBOOK_ADD_COLUMN: "pricebook.add_column",
  PRICEBOOK_ADD_PRICEBOOK: "quoting.pricebook",
  PRICEBOOK_CLAUSE_ASSOCIATION: "pricebook.clause_association",
  PRICEBOOK_DEAL_PROPERTISE: "pricebook.deal_propertise",
  PRICEBOOK_TOGGLE_STATUS: "pricebook.toggle_status",
  QUOTING_DIY_PRICING: "quoting.diy_pricing",
  QUOTING_BUNDLE_PRICING: "quoting.bundle_pricing",
  QUOTING_BUNDLE_PRODUCT: "quoting.bundle_product",

  // PRODUCT_FEATURES
  PRODUCT_ADD_PRODUCT: "product.add_product",
  PRODUCT_MODIFY_PRODUCT: "product.modify_product",
  PRODUCT_HIDDEN: "quoting.product_catalog",

  // TEMPLATES_FEATURES
  DOCUMENTS_CONTENT_LOCKING: "documents.content_locking",
  TEMPLATES_ADD_CLAUSE_LIST: "templates.add_clause_list",
  TEMPLATES_CLAUSE_OPTIONS: "templates.clause_options",
  TEMPLATES_IMAGE_FIELD: "templates.image_field",
  TEMPLATES_CUSTOM_VARIABLES: "templates.custom_variables",
  TEMPLATES_WORKFLOW_DF: "templates.workflow_df",
  TEMPLATES_USERGROUPS: "templates.usergroups",
  // WORKFLOW_FEATURES
  WORKFLOW_CREATE_NEW: "wf.dt_workflow",
  WORKFLOW_PRICEBOOK_LEVEL: "workflow.pricebook_level",
  WORKFLOW_SKU_LEVEL: "workflow.sku_level",
  WF_CLAUSE_OPTIONS: "wf.clause_options",
  WF_STANDARD_VARIABLES: "wf.standard_variables",
  WF_CUSTOM_VARIABLES: "wf.custom_variables",

  // CRM INTEGRATIONS
  INTG_SALESFORCE_STANDARD: "intg.salesforce_standard",
  INTG_ZOHO: "intg.zoho",
  INTG_ZAPIER: "intg.zapier",
  INTG_STRIPE: "intg.stripe",
  INTG_BOX: "intg.box",
  INTG_PAYPAL: "intg.paypal",

  // SYSTEM
  SYSTEM_CUSTOM_ROLES: "system.custom_roles",
  SYSTEM_USER_MANAGEMENT: "system.user_management",
  SYSTEM_SSO: "system.sso",
  SYSTEM_ROLES: "system.roles",
  SYSTEM_USER_GROUP: "system.usergroups",

  /**
   * NEW FEATURE GATING ADDED ON PRICING PLAN V4
   */

  // DOCUMENT_FEATURE
  DOCUMENT_ACTIVITY: "documents.activity_tracking",
  DOCUMENT_NOTES: "documents.indoc_comments",
  DOCUMENT_ATTACHMENT: "documents.attachment",
  DOCUMENT_PAYMENT: "documents.payment",
  DOCUMENT_GOOGLESHEET: "intg.gsheet",
  DOCUMENT_VIDEO_KYC: "documents.video_consent",
  DOCUMENTS_PERMALINK: "documents.permalink",
  DOCUMENTS_SNAPLINK: "documents.snaplink",
  DOCUMENTS_WEBFORMS: "documents.webforms",
  DOCUMENTS_BULK_SEND: "documents.bulk_send",
  METALENS: "metalens",
  DOCUMENT_RECEPIENT_FORM_FILLING: "documents.recepient_form_filling",
  DOCUMENT_CUSTOM_VIDEO_MESSAGE: "documents.custom_video_message",
  DOCUMENT_CUSTOM_TEXT_MESSAGE: "documents.custom_text_message",
  DOCUMENT_FORWARDING: "documents.document_forwarding",

  // ESIGNATURE
  ESIGNATURE_SMS_AUTH: "esign.sms_auth",
  ESIGNATURE_SMS_ESIGN_LINK: "esign.sms_esign_link",
};

export const FEATURES_DISPLAY_NAME = {
  ADD_TO_CLAUSE_LIST: "Dynamic Clauses and Workflow Rules",
  ADDING_PRICEBOOKS: "Multiple Price Book Advantage",
  WORKFLOW_ON_DF: "Workflow Rules on Form Fields",
  WORKFLOWS: "Workflows",
};

export const PRO_FEATURES_DESCRIPTION =
  "Our solution expert will walk you through this feature, so you could unlock the value";

export const UPGRADE_TEXT = {
  [FEATURES_NAME.ESIGN_SIGNATURES]: {
    displayName: "e-Signature",
    welcomeMsg: "Great! Looks like your business is growing!",
    upsaleMsg:
      "Upgrade to a higher plan for sending more documents for signature and using many more impressive features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
    counterData: {
      title: "E-signs consumed",
    },
  },
  [FEATURES_NAME.SYSTEM_USER_MANAGEMENT]: {
    displayName: "User management",
    welcomeMsg: "Great!Looks like your team is growing!",
    upsaleMsg:
      "Upgrade to a higher plan for adding more users to your account and experience amazing features!",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
    counterData: {
      title: "Users consumed",
    },
  },
  [FEATURES_NAME.SYSTEM_SSO]: {
    displayName: "SSO",
    welcomeMsg: "Want to benefit from Revv SSO feature for improved security?",
    upsaleMsg:
      "Upgrade to a higher plan to get SSO and many more awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.DOCUMENTS_EXPORT_TO_DOCX]: {
    displayName: "Export to MS Word (.docx)",
    welcomeMsg: "Elevate your Revv experience with more features like these!",
    upsaleMsg:
      "Upgrade to a higher plan to start using the export feature and more.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.WF_CLAUSE_OPTIONS]: {
    displayName: "Conditional Workflows (Clause Options)",
    welcomeMsg:
      "Elevate your Revv experience with workflow based on clause options!",
    upsaleMsg:
      "Upgrade to a higher plan to start using workflows and more awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.DOCUMENTS_CONTENT_LOCKING]: {
    displayName: "Content locking",
    welcomeMsg: "You need to upgrade to get the content locking feature!",
    upsaleMsg:
      "Upgrade to a higher plan for using content lock and much more features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.TEMPLATES_CUSTOM_VARIABLES]: {
    displayName: "Custom variables in templates",
    welcomeMsg:
      "Wow! Want to empower your team with custom variable flexibility in templates?",
    upsaleMsg:
      "Upgrade to a higher plan for using variables and much more features!",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.TEMPLATES_CLAUSE_OPTIONS]: {
    displayName: "Clause options in templates",
    welcomeMsg: "Great! You discovered a premium feature.",
    upsaleMsg:
      "Upgrade to a higher plan for using clause options and many other impressive features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.TEMPLATES_IMAGE_FIELD]: {
    displayName: "Image form field in templates",
    welcomeMsg: "Great! You discovered a premium feature.",
    upsaleMsg:
      "Upgrade to a higher plan for using image form field and many other impressive features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.WORKFLOW_CREATE_NEW]: {
    displayName: `${DEAL_LABELS["deal-table-label"]} Workflow`,
    welcomeMsg: `It looks like you are interested in our ${DEAL_LABELS[
      "deal-table-label"
    ].toLocaleLowerCase()} based workflow feature!`,
    upsaleMsg:
      "Upgrade to a higher plan to start using workflows and more awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.QUOTING_DIY_PRICING]: {
    displayName: "On Demand Pricing (DIY Pricing)",
    welcomeMsg:
      "Are you looking for more flexibility in the quote/pricing table?",
    upsaleMsg:
      "Upgrade to a higher plan for benefiting from more features like DIY pricing.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.QUOTING_BUNDLE_PRICING]: {
    displayName: "Bundle Pricing",
    welcomeMsg:
      "Would you like to benefit from more features like Bundle pricing?",
    upsaleMsg:
      "Upgrade to a higher plan for bundle price and many other awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.INTG_SALESFORCE_STANDARD]: {
    displayName: "Salesforce Standard",
    welcomeMsg:
      "You need to upgrade to a higher plan for integrating Revv with Salesforce!",
    upsaleMsg:
      "Upgrade to a higher plan for integration with Salesforce and many more awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.INTG_ZOHO]: {
    displayName: "Zoho",
    welcomeMsg:
      "You need to upgrade to a higher plan for integrating Revv with Zoho!",
    upsaleMsg:
      "Upgrade to a higher plan for integration with Zoho and many more awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.SYSTEM_CUSTOM_ROLES]: {
    displayName: "Custom roles",
    welcomeMsg: "It looks like you are interested in the custom role feature!",
    upsaleMsg:
      "Upgrade to a higher plan for benefiting from Revv custom role and many other awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.DOCUMENTS_THIRD_PARTY_UPLOAD]: {
    displayName: "Third-party paper upload",
    welcomeMsg: "Want to benefit from more features like this?",
    upsaleMsg:
      "Upgrade to a higher plan for using import third party documents feature and much more!",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.PRICEBOOK_ADD_PRICEBOOK]: {
    displayName: "Pricebook",
    welcomeMsg:
      "You need to upgrade your plan to get unlimited price books feature!",
    upsaleMsg:
      "Upgrade to a higher plan for benefiting from unlimited price books and other awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.WF_STANDARD_VARIABLES]: {
    displayName: "Conditional Workflows (Custom Variables)",
    welcomeMsg:
      "Would you like to benefit from more features like custom fields based workflows?",
    upsaleMsg:
      "Upgrade to a higher plan to start using workflows and more awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
    counterData: {
      title: "Workflow Consumed",
    },
  },
  [FEATURES_NAME.QUOTING_BUNDLE_PRODUCT]: {
    displayName: "Product - Bundle",
    welcomeMsg:
      "Are you looking for more flexibility in product catalog and pricing with features like bundle products?",
    upsaleMsg:
      "Upgrade to a higher plan for bundle product pricing and many other awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
};

export const UPGRADE_POPUP_TYPE = {
  generic: { name: "generic", eventName: "FREE_UPGRADE_COMMON" },
  permalink: { name: "magicLink", eventName: "FREE_UPGRADE_FOR_MAGIC_LINK" },
  snaplink: { name: "snapLink", eventName: "FREE_UPGRADE_FOR_SNAP_LINK" },
  esignatures: { name: "eSign", eventName: "FREE_UPGRADE_FOR_ESIGN" },
  [FEATURES_NAME.DOCUMENT_FORWARDING]: {
    name: "generic",
    eventName: "FREE_UPGRADE_COMMON",
  },
  document_downloaded: {
    name: "download",
    eventName: "FREE_UPGRADE_FOR_DOWNLOAD",
  },
  digital_transactions: {
    name: "digitalTransactions",
    eventName: "",
  },
  send_for_acceptance: {
    name: "sendForAcceptance",
    eventName: "FREE_UPGRADE_FOR_ACCEPTANCE",
  },
  send_to_someone: {
    name: "sendToSomeone",
    eventName: "",
  },
  web_form_link: {
    name: "webForm",
    eventName: "",
  },
  metalense: {
    name: "metalense",
    eventName: "",
  },
  [FEATURES_NAME.ESIGNATURE_SMS_AUTH]: {
    name: "smsAuth",
    eventName: "",
  },
  [FEATURES_NAME.ESIGNATURE_SMS_ESIGN_LINK]: {
    name: "smsEsignLink",
    eventName: "",
  },
  [FEATURES_NAME.DOCUMENT_VIDEO_KYC]: {
    name: "videoConsent",
    eventName: "",
  },
  [FEATURES_NAME.DOCUMENT_ATTACHMENT]: {
    name: "attachment",
    eventName: "",
  },
  [FEATURES_NAME.DOCUMENT_PAYMENT]: {
    name: "payment",
    eventName: "",
  },
  [FEATURES_NAME.DOCUMENT_NOTES]: {
    name: "notes",
    eventName: "",
  },
  [FEATURES_NAME.DOCUMENT_GOOGLESHEET]: {
    name: "gsheet",
    eventName: "",
  },
  [FEATURES_NAME.SYSTEM_ROLES]: {
    name: "roles",
    eventName: "",
  },
  [FEATURES_NAME.DOCUMENT_ACTIVITY]: {
    name: "activityTracking",
    eventName: "",
  },
  [FEATURES_NAME.WF_CUSTOM_VARIABLES]: {
    name: "workflowCustomField",
    eventName: "",
  },
  [FEATURES_NAME.WF_CLAUSE_OPTIONS]: {
    name: "formfieldClauseOptions",
    eventName: "",
  },
  [FEATURES_NAME.DOCUMENTS_BULK_SEND]: {
    name: "bulkSend",
    eventName: "",
  },
  [FEATURES_NAME.INTG_SALESFORCE_STANDARD]: {
    name: "customIntegrations",
    eventName: "",
  },
  [FEATURES_NAME.INTG_ZOHO]: {
    name: "customIntegrations",
    eventName: "",
  },
  [FEATURES_NAME.INTG_ZAPIER]: {
    name: "zapier",
    eventName: "",
  },
  [FEATURES_NAME.INTG_STRIPE]: {
    name: "stripe",
    eventName: "",
  },
  [FEATURES_NAME.INTG_BOX]: {
    name: "box",
    eventName: "",
  },
  [FEATURES_NAME.INTG_PAYPAL]: {
    name: "paypal",
    eventName: "",
  },
  [FEATURES_NAME.DOCUMENTS_CONTENT_LOCKING]: {
    name: "contentLocking",
    eventName: "",
  },
  [FEATURES_NAME.TEMPLATES_CLAUSE_OPTIONS]: {
    name: "clauseOptions",
    eventName: "",
  },
  [FEATURES_NAME.TEMPLATES_CUSTOM_VARIABLES]: {
    name: "customFormField",
    eventName: "",
  },
  [FEATURES_NAME.TEMPLATES_USERGROUPS]: {
    name: "userGroups",
    eventName: "",
  },
  [FEATURES_NAME.SYSTEM_USER_GROUP]: {
    name: "systemUserGroups",
    eventName: "",
  },
  [FEATURES_NAME.DOCUMENT_RECEPIENT_FORM_FILLING]: {
    name: "formFilling",
    eventName: "",
  },
  [FEATURES_NAME.DOCUMENT_CUSTOM_VIDEO_MESSAGE]: {
    name: "generic",
    eventName: "",
  },
  [FEATURES_NAME.DOCUMENT_CUSTOM_TEXT_MESSAGE]: {
    name: "generic",
    eventName: "",
  },
  bulk_auto_signer: {
    name: "bulkAutoSigner",
    eventName: "",
  },
};

export const LIMIT_EXHAUST_TEXT = {
  esignatures:
    "You have reached the maximum limit of eSigns. Upgrade now to get more!",
  document_downloaded: "You've exhausted your downloads quota. Upgrade now!",
  send_for_acceptance:
    "You have reached the maximum limit of sending documents for acceptance. Upgrade now to get more!",
  send_to_someone:
    "You have reached the maximum limit of sending documents. Upgrade now to get more!",
  permalink: "magiclink",
  snaplink: "snaplink",
  web_form_link:
    "You have reached the maximum limit of web form. Upgrade now to get more!",
  digital_transactions:
    "You have reached the maximum limit of digital transactions. Upgrade now to get more!.",
};

export const LIMIT_USAGE_TEXT = {
  esignatures: "You can send [x] more documents for eSign. Click to upgrade.",
  document_downloaded: "You can download [x] more documents. Click to upgrade",
  send_for_acceptance:
    "You can send [x] more documents for consent. Click to upgrade.",
  send_to_someone:
    "You can share [x] more documents with recipients . Click to upgrade",
  permalink: "magiclink",
  snaplink: "snaplink",
  web_form_link:
    "You can send [x] more documents for web form. Click to upgrade.",
  digital_transactions: "You have [x] digital transactions left for use.",
};

export const PAID_USER_LIMIT_USAGE_TEXT = {
  esignatures: "You have [x] of [y] eSign transactions left for use.",
  document_downloaded: "You can download [x] documents via email.",
  send_for_acceptance:
    "You have [x] of [y] acceptance transactions left for use",
  send_to_someone: "You can send [x] documents via email.",
  permalink: "magiclink",
  snaplink: "snaplink",
  web_form_link: "You have [x] of [y] web form transactions left for use.",
  digital_transactions:
    "You have [x] of [y] digital transactions left for use.",
};
